import { Link } from "react-router-dom";

export function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Settings</h1>
        <p className="text-muted-foreground mt-2">
          Manage your application settings
        </p>
      </div>

      <div className="rounded-lg border bg-card p-6">
        <h2 className="text-lg font-semibold mb-4">Application Configuration</h2>
        <div className="space-y-2 text-sm">
          <p className="text-muted-foreground">Open an admin settings module:</p>
          <div className="flex gap-3">
            <Link className="text-primary underline-offset-4 hover:underline" to="/settings/ai-apps">
              AI Apps
            </Link>
            <Link className="text-primary underline-offset-4 hover:underline" to="/settings/users">
              Users
            </Link>
            <Link className="text-primary underline-offset-4 hover:underline" to="/settings/audit-logs">
              Audit Logs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
